// Which on-screen element Edgar highlights after "Take me there" (first one found wins).
export const SHOW = {
  create: ["upload-photo-button", "uploader-dropzone"],
  batch: ["batch-builder", "batch-new"],
  merge: ["batch-merge-toggle", "batch-merge-open", "batch-list", "batch-builder"],
  unmerge: ["batch-unmerge", "batch-merge-toggle", "batch-list"],
  move: ["batch-move-items", "batch-list"],
  fix: ["batch-rows", "batch-list"],
  retry: ["batch-retry", "batch-list"],
  research: ["research-mode-single", "research-mode-toggle"],
  worth: ["research-mode-worth"],
  media: ["research-mode-media"],
  keepers: ["keepers-bar", "research-mode-toggle"],
  library: ["library-search"],
  post: ["open-ebay-settings"],
  listings: ["my-listings-search"],
  dashboard: ["dashboard-sync-button"],
  "alerts-clear": ["run-reports-clear-all", "run-reports-card"],
  extension: ["extension-connect-btn", "extension-connect-page"],
  team: ["open-team"],
  assign: ["batch-assign", "batch-list"],
  message: ["dashboard-nudge-bar"],
  queue: ["queue-next-card", "lister-queue"],
  "owner-msg": ["open-inbox", "nav-queue"],
  earnings: ["open-my-earnings"],
  notifications: ["alert-settings", "open-alert-settings"],
  billing: ["header-pro-badge", "header-trial-badge", "header-starter-badge", "header-go-pro-link"],
  invite: ["invite-copy-btn", "invite-link"],
  rare: ["nav-research"],
  cost: ["batch-combine-toggle", "batch-list"],
  scanform: ["scan-form-open-ebay", "scan-form-card"],
};

// Top questions per page, shown when Edgar opens there.
export const PAGE_TIPS = {
  "/": { name: "Create", ids: ["create", "post", "library"] },
  "/batch": { name: "Batches", ids: ["merge", "move", "fix", "cost"] },
  "/research": { name: "Research", ids: ["research", "worth", "media", "keepers"] },
  "/library": { name: "Library", ids: ["library", "post", "keepers"] },
  "/listings": { name: "Listings", ids: ["listings", "post"] },
  "/dashboard": { name: "Dashboard", ids: ["dashboard", "alerts-clear", "scanform", "message"] },
  "/extension": { name: "Extension", ids: ["extension"] },
  "/team": { name: "Team", ids: ["team", "assign", "message"] },
  "/queue": { name: "Queue", ids: ["queue", "fix", "owner-msg"] },
  "/alerts": { name: "Alerts", ids: ["notifications"] },
  "/billing": { name: "Plan & Billing", ids: ["billing", "invite"] },
  "/earnings": { name: "My earnings", ids: ["earnings"] },
};

// Ring + label over the element for a few seconds; waits for the page to render it.
export function highlight(ids, tries = 25) {
  const el = ids.map((id) => document.querySelector(`[data-testid="${id}"]`)).find((e) => e && e.getClientRects().length);
  if (!el) { if (tries > 0) setTimeout(() => highlight(ids, tries - 1), 200); return; }
  el.scrollIntoView({ block: "center", behavior: "smooth" });
  setTimeout(() => {
    const r = el.getBoundingClientRect();
    const ring = document.createElement("div");
    ring.setAttribute("data-testid", "edgar-highlight");
    ring.className = "edgar-ring";
    Object.assign(ring.style, { top: `${r.top - 6}px`, left: `${r.left - 6}px`, width: `${r.width + 12}px`, height: `${r.height + 12}px` });
    const tag = document.createElement("span");
    tag.textContent = "Here it is";
    tag.className = "edgar-ring-tag";
    ring.appendChild(tag);
    document.body.appendChild(ring);
    const off = () => { ring.remove(); window.removeEventListener("scroll", off, true); };
    window.addEventListener("scroll", off, { capture: true, once: true });
    setTimeout(off, 4500);
  }, 450);
}
